export default function spaces ( i ) {
	let result = '';
	while ( i-- ) result += ' ';
	return result;
}
